import { HighChartDataPoints } from "../../models/data-point/highchart-data-points.model";
import { IndicatorClassAndColor, IndicatorColorType, TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";
import { TIIndicatorPointModel } from "../../models/data-point/ti-indicator-point.model";
import { IndicatorType } from "../../models/enum/indicator-type.enum";

export class TIIndicatorPointToHighChartIndicatorPointMapper {
    public static map(rawData: TIIndicatorDataModel, indicatorType: IndicatorType, needHighChartZoneColor: boolean): HighChartDataPoints {
        let dataPoints: Array<any> = [];
        let dataPointsZone: Array<any> = [];
        let lastZonePoint: any = null;
        if (rawData && rawData.points?.length) {
            for (const data of rawData.points) {
                dataPoints.push(TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorType, data, rawData));

                if (needHighChartZoneColor) {
                    const zonePoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(data, rawData);
                    if (lastZonePoint == null || lastZonePoint.className != zonePoint.className) {
                        if (lastZonePoint == null || lastZonePoint.className != zonePoint.className) {
                            dataPointsZone.push(zonePoint);
                            lastZonePoint = zonePoint;
                        }
                    }
                }
            }
        }

        return new HighChartDataPoints({
            points: dataPoints,
            zones: dataPointsZone
        });
    }

    public static toHighChartIndicatorPoint(indicatorType: IndicatorType, point: TIIndicatorPointModel, rawData: TIIndicatorDataModel): any {
        const className = rawData.colorType == IndicatorColorType.One ? rawData.getClassName() : point.pointColorToClassName(rawData.getClassName());
        if (!rawData.colors.some((x: IndicatorClassAndColor) => x.className == className)) {
            rawData.colors.push({
                className: className,
                color: point.color
            });
        }

        if (indicatorType == IndicatorType.Volume) {
            return { x: point.xValue, y: point.value, color: point.color, className: className };
        } else if (indicatorType == IndicatorType.AverageVolume) {
            return { x: point.xValue, y: point.volumeAvg, color: point.color, className: className };
        }

        return { x: point.xValue, y: point.value, color: point.color, className: className };
    }

    public static toHighChartZone(point: TIIndicatorPointModel, rawData: TIIndicatorDataModel): any {
        const className = point.pointColorToClassName(rawData.getClassName());
        if (!rawData.colors.some((x: IndicatorClassAndColor) => x.className == className)) {
            rawData.colors.push({
                className: className,
                color: point.color
            });
        }

        return {
            value: point.xValue,
            className: className
        };
    }
}